import { Link } from "react-router-dom";

const FULL = "https://customer-assets-cm19k8pv.emergentagent.net/job_5678272a-ccad-4e00-8261-938d1577529f/artifacts/4znlcjae_KKASHIGARI.png";
const MONOGRAM = "https://customer-assets-cm19k8pv.emergentagent.net/job_5678272a-ccad-4e00-8261-938d1577529f/artifacts/byrecvnw_image.png";

export function Logo({ variant = "full", className = "", to = "/" }) {
  const src = variant === "monogram" ? MONOGRAM : FULL;
  return (
    <Link to={to} data-testid="brand-logo" className={`inline-block ${className}`}>
      <img src={src} alt="KKashigari India" className="h-full w-auto object-contain" />
    </Link>
  );
}
